﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import VehicleDetails from "./Registration/VehicleDetails.svelte";
import DocumentUpload from "./Registration/DocumentUpload.svelte";
import Agreements from "./Registration/Agreements.svelte";
import Confirmation from "./Registration/Confirmation.svelte";
import ThankYou from "./Registration/ThankYou.svelte";
import Review from "./Registration/Review.svelte";

import FileUploadLandingPage from "./FileUpload/LandingPage.svelte";
import FileUploadFilesPage from "./FileUpload/Files.svelte";
import FileUploadThankYouPage from "./FileUpload/ThankYou.svelte";

import AgreementsLandingPage from "./Agreements/LandingPage.svelte";
import AgreementsAgreement from "./Agreements/Agreement.svelte";
import AgreementsThankYouPage from "./Agreements/ThankYou.svelte";

import AdditionalInformationLandingPage from "./AdditionalInformation/LandingPage.svelte";
import AdditionalInformationSurvey from "./AdditionalInformation/Survey.svelte";
import AdditionalInformationThankYouPage from "./AdditionalInformation/ThankYou.svelte";

import Error from "./Error.svelte";


const title = 'Toyota DPF Action';

export const registrationPageList = [
    {
        pageIndex: 0,
        component: LandingPage,
        title: "Claimant Registration Form",
        showInTracker: true,
        routeId: "/",
        nextPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: title,
            lastVisitedPage: "Landing Page",
        },
    },
    {
        pageIndex: 1,
        component: LandingPage,
        title: "Claimant Registration Form",
        showInTracker: true,
        routeId: "/Registration",
        nextPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: title,
            lastVisitedPage: "Landing Page",
        },
    },
    {
        pageIndex: 2,
        component: PersonalDetails,
        title: "Personal Details",
        showInTracker: true,
        routeId: "/Registration/PersonalDetails",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/VehicleDetails",
        previousPage: "/Registration",
        properties: {
            pageTitle: title + ` - Personal Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Personal Details",
            gtmPhase: 1,
        },
    },
    {
        pageIndex: 3,
        component: VehicleDetails,
        title: "Vehicle Details",
        showInTracker: true,
        routeId: "/Registration/VehicleDetails",
        nextPage: (model) => model.confirmationPage ? "/Registration/Confirmation" : "/Registration/DocumentUpload",
        previousPage: "/Registration/PersonalDetails",
        properties: {
            pageTitle: title + ` - Vehicle Details`,
            persistUrl: "/api/project",
            lastVisitedPage: "Vehicle Details",
            gtmPhase: 2,
        },
    },
    {
        pageIndex: 4,
        component: DocumentUpload,
        title: "Document Upload",
        showInTracker: true,
        routeId: "/Registration/DocumentUpload",
        nextPage: "/Registration/Confirmation",
        previousPage: "/Registration/VehicleDetails",
        properties: {
            pageTitle: title + ' - Document Upload',
            persistUrl: "/api/project",
            lastVisitedPage: "Document Upload",
            gtmPhase: 3,
        },
    },
    //{
    //    pageIndex: 5,
    //    component: Agreements,
    //    title: "Funding Agreement and Cost Agreement",
    //    showInTracker: true,
    //    routeId: "/Registration/Agreements",
    //    nextPage: "/Registration/Confirmation",
    //    previousPage: "/Registration/DocumentUpload",
    //    properties: {
    //        pageTitle: title + ' - Funding Agreement and Cost Agreement',
    //        persistUrl: "/api/project",
    //        lastVisitedPage: "Agreements",
    //    },
    //},
    {
        pageIndex: 6,
        component: Confirmation,
        title: "Confirmation",
        showInTracker: true,
        routeId: "/Registration/Confirmation",
        previousPage: "/Registration/DocumentUpload",
        nextPage: "/Registration/ThankYou",
        properties: {
            pageTitle: title + ` - Confirmation`,
            nextPageLabel: "Submit",
            persistUrl: `/api/registration?timezoneOffset=${(-1 * (new Date().getTimezoneOffset()))}`,
            lastVisitedPage: "Confirmation",
            gtmPhase: 4,
        },
    },
    {
        pageIndex: 7,
        component: ThankYou,
        title: "Registration Submitted",
        showInTracker: false,
        routeId: "/Registration/ThankYou",
        properties: {
            pageTitle: title + ` - Thank you`,
        },
    },
    {
        pageIndex: 9,
        component: Review,
        title: "Review",
        showInTracker: false,
        routeId: "/Review",
        properties: {
            pageTitle: title + ` - Review`,
        },
    },
    {
        pageIndex: 10,
        component: Error,
        title: "Error",
        showInTracker: false,
        routeId: "*/Error",
        properties: {
            pageTitle: title + ` - Error`,
        },
    },
];

export const fileUploadPageList = [
    {
        pageIndex: 0,
        component: FileUploadLandingPage,
        title: "Landing Page",
        showInTracker: false,
        routeId: "/FileUpload",
        nextPage: "/FileUpload/Files",
        properties: {
            pageTitle: `${title}`,
        },
    },
    {
        pageIndex: 1,
        component: FileUploadFilesPage,
        title: "File upload form",
        showInTracker: true,
        routeId: "/FileUpload/Files",
        nextPage: "/FileUpload/ThankYou",
        properties: {
            pageTitle: `${title} - File Upload`,
            persistUrl: "/api/file-upload-submit",
            lastVisitedPage: "File Upload Landing Page",
        },
    },
    {
        pageIndex: 2,
        component: FileUploadThankYouPage,
        title: "File Upload",
        showInTracker: false,
        routeId: "/FileUpload/ThankYou",
        properties: {
            pageTitle: `${title} - Thank You`,
        },
    },
    {
        pageIndex: 3,
        component: Error,
        title: "Error",
        showInTracker: false,
        pageTitle: `${title} - Error`,
    },
];

export const agreementPageList = [
    {
        pageIndex: 0,
        component: AgreementsLandingPage,
        title: "Landing Page",
        showInTracker: false,
        routeId: "/Agreements",
        nextPage: "/Agreements/ConfirmAgreements",
        properties: {
            pageTitle: `${title}`,
        },
    },
    {
        pageIndex: 1,
        component: AgreementsAgreement,
        title: "Agreements Confirmation",
        showInTracker: true,
        routeId: "/Agreements/ConfirmAgreements",
        nextPage: "/Agreements/ThankYou",
        properties: {
            pageTitle: `${title} - Confirm Agreements`,
            persistUrl: `/api/confirm-agreements?timezoneOffset=${(-1 * (new Date().getTimezoneOffset()))}`,
        },
    },
    {
        pageIndex: 2,
        component: AgreementsThankYouPage,
        title: "Agreements Submitted",
        showInTracker: false,
        routeId: "/Agreements/ThankYou",
        properties: {
            pageTitle: `${title} - Thank You`,
        },
    },
    {
        pageIndex: 3,
        component: Error,
        title: "Error",
        showInTracker: false,
        pageTitle: `${title} - Error`,
    },
];

export const additionalInformationPageList = [
    {
        pageIndex: 0,
        component: AdditionalInformationLandingPage,
        title: "Landing Page",
        showInTracker: false,
        routeId: "/AdditionalInformation",
        nextPage: "/AdditionalInformation/Survey",
        properties: {
            pageTitle: `${title}`,
        },
    },
    {
        pageIndex: 1,
        component: AdditionalInformationSurvey,
        title: "Survey",
        showInTracker: true,
        routeId: "/AdditionalInformation/Survey",
        nextPage: "/AdditionalInformation/ThankYou",
        properties: {
            pageTitle: `${title} - Additional Information`,
            persistUrl: `/api/additional-information`,
        },
    },
    {
        pageIndex: 2,
        component: AdditionalInformationThankYouPage,
        title: "Additional Information Submitted",
        showInTracker: false,
        routeId: "/AdditionalInformation/ThankYou",
        properties: {
            pageTitle: `${title} - Thank You`,
        },
    },
    {
        pageIndex: 3,
        component: Error,
        title: "Error",
        showInTracker: false,
        pageTitle: `${title} - Error`,
    },
];
